import React, { useEffect, useRef } from 'react';
import {
    getFramework,
    getOperateType,
    getPointRect,
    MoveListenerLevel,
    OperateClickEvents,
    useIdentity,
    useMoveEventListener,
} from '@/framework';
import { ITouchKitEvent } from '@/utils/event-kit';
import { BaseLayerViewType } from '@/version-types';
import { useMoveOperate } from '../hooks/use-move-operate';
import { getMoveState } from '../states/move-state';

export const MoveOperate: React.FC<{ layerId: string }> = ({ layerId }) => {
    const identity = useIdentity();
    const moveOperate = useMoveOperate();
    const framework = getFramework(identity);
    const moveEventRef = useRef<MouseEvent | null>(null);

    function checkCanMove(e: ITouchKitEvent) {
        const target = e.target;
        if (!target) return;
        const operateType = getOperateType(target);
        if (operateType !== BaseLayerViewType.MOVE) {
            if (!operateType && moveEventRef.current) {
                const activeLayer = framework.service.frame.getActiveLayer();
                if (activeLayer) {
                    const pointRect = getPointRect(framework.service.transform.getScenePoint(e.originEvent));
                    const layerId = framework.service.transform.tryPickWrap(pointRect, [
                        framework.service.flatLayer.getLayer(activeLayer.id),
                    ]);
                    if (layerId && !framework.service.flatLayer.getLayer(layerId).lock) {
                        getMoveState(identity).setMoveLayerId(layerId);
                        return;
                    }
                }
            }
            getMoveState(identity).setMoveLayerId('');
            return;
        }
        getMoveState(identity).setMoveLayerId(layerId);
    }

    // const events = useElementClickEvents(layerId, {
    //     onClick: (e) => {
    //         framework.service.frame.__emitLayerClickEvent(layerId, {
    //             x: e.pageX || 0,
    //             y: e.pageY || 0,
    //         });
    //     },
    //     onDoubleClick: (e) => {
    //         framework.service.frame.__emitLayerDoubleClickEvent(layerId, {
    //             x: e.pageX || 0,
    //             y: e.pageY || 0,
    //         });
    //     },
    // });

    useEffect(() => {
        return () => {
            getMoveState(identity).setMoveLayerId(null);
        };
    }, [layerId]);

    useMoveEventListener(
        (e) => {
            // if (framework.operate.isDisableMove()) return;
            if (e.isStart) {
                moveEventRef.current = e.originEvent;
            }
            let moveLayerId = getMoveState(identity).getMoveLayerId();
            if (moveLayerId === null) {
                checkCanMove(e);
                moveLayerId = getMoveState(identity).getMoveLayerId();
            }
            if (moveLayerId) {
                if (e.isStart) {
                    moveOperate.beforeMove(moveLayerId);
                }
            }
        },
        MoveListenerLevel.PREPARE_LEVEL,
        'move-pre',
    );

    useMoveEventListener(
        (e) => {
            // if (framework.operate.isDisableMove()) return;
            const moveLayerId = getMoveState(identity).getMoveLayerId();
            if (moveLayerId) {
                moveOperate.move(moveLayerId, e);
            }
            if (e.isEnd) {
                getMoveState(identity).setMoveLayerId(null);
            }
        },
        MoveListenerLevel.DEFAULT_LEVEL,
        'move-default',
    );

    // const isDisableMove = useIsDisableMove();
    // if (isDisableMove) return null;

    return (
        <OperateClickEvents
            layerId={layerId}
            dataOperateType={BaseLayerViewType.MOVE}
            className="active-operate__move"
        />
    );

    // return <div data-operate-type={BaseLayerViewType.MOVE} className="active-operate__move" {...events}></div>;
};
